// extracted by mini-css-extract-plugin
module.exports = {"chat-finished__greeting":"chat-finished__greeting__zxo1Q","chat-finished__message":"chat-finished__message__2Ly5q"};